import { defineComponent, ref, watch, getCurrentInstance } from "vue";
import { definePropType } from "@types-vue/props";
export default defineComponent({
    props: {
        config: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        },
        model: {
            type: definePropType(Object),
            required: true
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var formModel = ref();
        watch(function() {
            return props.model;
        }, function(val) {
            formModel.value = val;
        }, {
            immediate: true
        });
        var inputChange = function(keyWord) {
            formModel.value["page"] = 1;
            if (props.config.handleChange) {
                props.config.handleChange(keyWord);
            } else {
                root.$router.push({
                    query: formModel.value
                });
            }
            emit("handleChange", keyWord);
        };
        return {
            formModel: formModel,
            inputChange: inputChange
        };
    }
});
